import React, { memo } from 'react';
import { Star } from '../../atoms';
import { RatingStarsContainer } from './Styled';

export interface RatingStarsProps {
  starCount?: 1 | 2 | 3 | 4 | 5;
  rating: number;
  size?: number;
}

const RatingStarsComponent = (props: RatingStarsProps) => {
  const { starCount, rating, size } = props;
  if (typeof rating !== 'number') {
    return null;
  }

  const parseInteger = (number: number) => Number.parseInt((number * 100).toFixed());

  const renderStar = Array.from(Array(starCount)).map((_, i) => {
    const full = rating > i + 1;
    const partial = parseInteger(rating - i);

    const fill = full ? 100 : partial > 0 ? partial : 0;
    return <Star key={partial} fillPercentage={fill} size={size} />;
  });

  return (
    <RatingStarsContainer theme={{ size }} className="product-review-rating-stars">
      {renderStar}
    </RatingStarsContainer>
  );
};

RatingStarsComponent.defaultProps = {
  starCount: 5,
  rating: 0,
  size: 24,
};

const RatingStars = memo(RatingStarsComponent);

export default RatingStars;
export { RatingStars };
